export const formatDate = (date : number) => {
    const dateToProcess = new Date(date)
    return `${dateToProcess.getDate()}-${dateToProcess.getMonth()+1}-${dateToProcess.getFullYear()}`
}

export const formatDateWithHours = (date: number) => {
    if(date == null) {
        return '-'
    }
    const dateToProcess = new Date(date)
    return `${dateToProcess.getDate()}-${dateToProcess.getMonth()+1}-${dateToProcess.getFullYear()} ${dateToProcess.getHours()}:${dateToProcess.getMinutes()}:${dateToProcess.getSeconds()}`
}

export function addDays(date : Date, days : number) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

